/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pie charts are clearest with a small number of categories. Group very small values into an “Other” slice to avoid clutter.`)
};

const es_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los gráficos circulares son más claros con un número reducido de categorías. Agrupa los valores muy pequeños en una porción «Otros» para evitar el desorden visual.`)
};

const de_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreisdiagramme sind mit einer kleinen Anzahl von Kategorien am übersichtlichsten. Fassen Sie sehr kleine Werte zu einem „Sonstiges“-Segment zusammen, um Unübersichtlichkeit zu vermeiden.`)
};

const nl_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cirkeldiagrammen zijn het duidelijkst met een klein aantal categorieën. Groepeer zeer kleine waarden in een segment "Overig" om rommeligheid te voorkomen.`)
};

const fr_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les diagrammes circulaires sont plus clairs avec un petit nombre de catégories. Regroupez les valeurs très petites dans un secteur « Autre » pour éviter l'encombrement.`)
};

const it_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I grafici a torta sono più chiari con un piccolo numero di categorie. Raggruppa i valori molto piccoli in una fetta “Altro” per evitare confusione.`)
};

const pt_br2_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráficos de pizza são mais claros com um número pequeno de categorias. Agrupe valores muito pequenos em uma fatia “Outros” para evitar poluição visual.`)
};

const pt_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os gráficos circulares são mais claros com um pequeno número de categorias. Agrupe valores muito pequenos numa fatia “Outros” para evitar confusão visual.`)
};

const ja_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`円グラフはカテゴリ数が少ないほど見やすくなります。非常に小さな値は「その他」のスライスにまとめて雑然とするのを避けてください。`)
};

const zh_pie_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`饼图在类别较少时最清晰。将非常小的数值归入“其他”扇形可以避免图表杂乱。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pie_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pie_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pie_faq_a3", locale)
	if (locale === "en") return en_pie_faq_a3(inputs)
	if (locale === "es") return es_pie_faq_a3(inputs)
	if (locale === "de") return de_pie_faq_a3(inputs)
	if (locale === "nl") return nl_pie_faq_a3(inputs)
	if (locale === "fr") return fr_pie_faq_a3(inputs)
	if (locale === "it") return it_pie_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_pie_faq_a3(inputs)
	if (locale === "pt") return pt_pie_faq_a3(inputs)
	if (locale === "ja") return ja_pie_faq_a3(inputs)
	return zh_pie_faq_a3(inputs)
};